export const SquadRole = Object.freeze({
    ADMIN: "ADMIN",
    MEMBER: "MEMBER",
});
